export default {
  title: 'student Form',
  detail: 'Create or update student information',
  mobile : 'mobile',
  birthDate:'birth date',
  schoolName:'school name',
  address:'Add Address',
  gender:'gender',
  male:'Male',
  female:'female',
  email:'email',
  email_verified_at:'email verified At',
  status: 'status',
  statusActive: 'active',
  statusInActive: 'inactive',
  lastName : 'last Name',
  firstName : 'first Name',
  back : 'back',
  success : 'success',
  error : 'error',
  save : 'save',
  loading : 'loading',
  saving : 'saving ...',
  country:'country',
  selectCountry:'select country',
  province:'province',
  selectProvince:'select province',
  city:'country',
  selectCity:'select city',
  placeholderMobile:'Enter mobile number',
  placeholderFirstName:'Enter first name',
  placeholderLastName:'Enter last name',
  placeholderSchoolName:'Enter school name',
  placeholderEmail:'Enter email address',




}
